var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ownersLoaded === true)?_c('multiselect',{attrs:{"placeholder":_vm.$t('common.selects.owner'),"track-by":"name","label":"name","id":"owner_id","options":_vm.owners.data},model:{value:(_vm.selectedOwner),callback:function ($$v) {_vm.selectedOwner=$$v},expression:"selectedOwner"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }